import moment from 'moment';

export const isCardExpired = (card) => {
  const hasExpDate = card?.expirationMonth && card?.expirationYear;
  if (!hasExpDate) return false;

  const lastMonth = moment().subtract(1, 'month');
  const expDate = moment(
    `${card.expirationMonth}/${card.expirationYear}`,
    'MM/YYYY',
  );

  return lastMonth.isAfter(expDate);
};
